export enum mapToApiModeTypes {
  DELETE = 'DELETE',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}

export type ApiMapper<R, F> = {
  mapFromApi?: (rawData: R) => F,
  // mapMode - Different CRUD operations require different mappings
  mapToApi?: (formattedData: F, mapMode: mapToApiModeTypes) => any,
};
